import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import TextField from '@mui/material/TextField';
import { makeStyles } from "@material-ui/core/styles";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  paper: {
    fontSize: '12px !important',    
  }
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [reason, setReason] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    if(props.dataObj!=null && props.dataObj.autoId){	
      setReason(props.dataObj.title);
    }
	}, [props.dataObj,userObj]);

	function saveData(){
    if(!reason){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter reason");			
      return false;
    }
    
		if(reason && reason.length>1){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('title', reason);

      let apiURL='/crm-create-lead-loss-reason';
      let myMessage="Lead loss reason has been created.";
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-lead-loss-reason';
          myMessage="Lead loss reason has been updated.";
      }
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setReason("");
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This lead loss reason was created earlier. Kindly enter another lead loss reason.");
            return false;  					
        }else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This lead loss reason could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}
  

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.dataObj!=null?<>Edit</>:<>New</>} Lead Loss Reason</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Reason</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setReason(event.target.value)} value={reason} placeholder={'Enter Reason'} fullWidth variant="standard" />
                            </td>                            
                        </tr>
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF'}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;